import React from 'react'

import Icon from '../Icon'
import { Container, Header, Title, Description } from './styles'

import { FeedbackCardProps, FeedbackIconType } from './type'
import { FeedbackCardTypeEnum } from './enum'
import { IconName } from '../Icon/enum'
import formatDateTime, { AllowedLocales } from '~/utils/date/formatDateTime'
import { useTranslation } from 'react-i18n-lite'

const FeedbackCard = ({
  title,
  message,
  type = FeedbackCardTypeEnum.default,
  heightClass = 'regular',
  displayDateTime = true
}: FeedbackCardProps) => {
  const iconType: { [key in FeedbackIconType]: IconName } = {
    warning: 'Spinner',
    error: 'Process'
  }
  const iconName = type in iconType ? iconType[type as FeedbackIconType] : null

  const { t } = useTranslation()

  const intlLocale = t('intl-locale') as AllowedLocales

  const getFormatedDateTime = () =>
    formatDateTime(new Date(), intlLocale, 'date-time').replace('|', '-')

  const finalMessage = `${
    displayDateTime ? `${getFormatedDateTime()} | ` : ''
  }${message}`

  return (
    <Container type={type} heightClass={heightClass}>
      <Header>
        <Title heightClass={heightClass}>{title}</Title>
        {iconName ? (
          <Icon iconName={iconName} icColor='blackText' icSize={heightClass} />
        ) : null}
      </Header>
      {message?.length ? (
        <Description heightClass={heightClass}>{finalMessage}</Description>
      ) : null}
    </Container>
  )
}

export default FeedbackCard
